import type { UrlStatusUpdate } from '@kanbu/schema/contracts';
import { Info } from 'lucide-preact';

import { StatusBar } from '@/components/status-bar/status-bar';
import { UrlList } from '@/components/url-list/url-list';
import { Wrapper } from '@/components/wrapper/wrapper';
import { tWebInput } from '@/lib/i18n';

interface InfoSectionProps {
  isLoading: boolean;
  urlStatusUpdates: UrlStatusUpdate[];
}

export function InfoSection({ isLoading, urlStatusUpdates }: InfoSectionProps) {
  const isUnused = !isLoading && urlStatusUpdates.length === 0;

  return (
    <Wrapper
      className={
        isUnused ? 'border-0 bg-transparent p-0 backdrop-blur-none' : undefined
      }
    >
      {isUnused && (
        <div className='flex gap-1.5'>
          <Info className='mt-0.5 size-3 shrink-0 text-[#9c70ff]/60' />
          <span className='text-[0.6875rem] leading-snug text-[#1a1a1a]/70'>
            {tWebInput('idleHint')}
          </span>
        </div>
      )}
      {isLoading && (
        <div className='flex flex-row items-center justify-between gap-3'>
          <StatusBar urls={urlStatusUpdates} />
          <span className='shrink-0 text-[10px] font-medium leading-tight text-[#1a1a1a]/40'>
            {tWebInput('learningDuration')}
          </span>
        </div>
      )}
      {urlStatusUpdates.length > 0 && (
        <UrlList urls={urlStatusUpdates} isLoading={isLoading} />
      )}
    </Wrapper>
  );
}
